/* Loupe – sticky add-to-cart bar for the product page.
   Shows once the main buy button has scrolled out of view, hides again near the footer.
   Content comes from <template data-sticky-atc> inside [data-product-info], which the variant picker
   re-renders via the Section Rendering API – so the bar always reflects the selected variant. */
(() => {
  if (customElements.get('loupe-sticky-atc')) return;

  class LoupeStickyAtc extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('[data-section-id]');
      this.inner = this.querySelector('[data-sticky-inner]');
      if (!this.section || !this.inner) return;
      this.past = false; this.nearFooter = false; this.forced = false;

      this.io = new IntersectionObserver((entries) => {
        const e = entries[entries.length - 1];
        this.past = !e.isIntersecting && e.boundingClientRect.top < innerHeight / 2;
        this.update();
      }, { rootMargin: `-${parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-h')) || 68}px 0px 0px 0px` });
      this.footerIo = new IntersectionObserver((entries) => {
        this.nearFooter = entries[0].isIntersecting; this.update();
      }, { rootMargin: '0px 0px 80px 0px' });

      this.footer = document.querySelector('.footer') || document.querySelector('footer');
      if (this.footer) this.footerIo.observe(this.footer);

      /* the variant picker replaces [data-product-info] – re-read the bar content and the form */
      const info = this.section.querySelector('[data-product-info]');
      this.mo = new MutationObserver(() => this.refresh());
      if (info && info.parentElement) this.mo.observe(info.parentElement, { childList: true });

      /* theme editor: show the bar while its block is selected */
      this.onSelect = (e) => { if (e.detail && e.detail.blockId === this.dataset.blockId) { this.forced = e.type === 'shopify:block:select'; this.update(); } };
      document.addEventListener('shopify:block:select', this.onSelect);
      document.addEventListener('shopify:block:deselect', this.onSelect);

      this.refresh();
    }

    disconnectedCallback() {
      this.io && this.io.disconnect(); this.footerIo && this.footerIo.disconnect();
      this.mo && this.mo.disconnect(); this.loadMo && this.loadMo.disconnect();
      document.removeEventListener('shopify:block:select', this.onSelect);
      document.removeEventListener('shopify:block:deselect', this.onSelect);
      document.body.classList.remove('has-sticky-atc');
    }

    refresh() {
      const tpl = this.section.querySelector('template[data-sticky-atc]');
      if (tpl) this.inner.replaceChildren(tpl.content.cloneNode(true)); else this.inner.replaceChildren();
      this.hasContent = !!tpl;

      const form = document.getElementById(this.dataset.form);
      if (form !== this.form) {
        if (this.watch) this.io.unobserve(this.watch);
        this.form = form;
        /* watch the add-to-cart button itself – the form can reach far below it */
        this.watch = form && (form.querySelector('[type=submit]') || form);
        if (this.watch) this.io.observe(this.watch);
      }

      /* mirror the loading spinner of the main add-to-cart button */
      this.loadMo && this.loadMo.disconnect();
      const main = form && form.querySelector('[type=submit]');
      const mine = this.inner.querySelector('[type=submit]');
      if (main && mine) {
        this.loadMo = new MutationObserver(() => mine.classList.toggle('is-loading', main.classList.contains('is-loading')));
        this.loadMo.observe(main, { attributes: true, attributeFilter: ['class'] });
      }
      this.update();
    }

    update() {
      const show = this.hasContent && !!this.form && (this.forced || (this.past && !this.nearFooter));
      if (show === this.visible) return;
      this.visible = show;
      this.classList.toggle('is-visible', show);
      this.toggleAttribute('inert', !show);
      this.setAttribute('aria-hidden', String(!show));
      document.body.classList.toggle('has-sticky-atc', show);
    }
  }

  customElements.define('loupe-sticky-atc', LoupeStickyAtc);
})();
